
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ChatReply/ChatReply.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ChatReply.html');
        
        var script = require('./ChatReply.ts').default;
        module.exports = require('./ChatReply.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    